<template>
  <v-container>
    <v-snackbar v-model="snackbar">
      Please select a client first.
    </v-snackbar>
    <v-row dense>
      <v-sheet class="flex-fill pb-4" color="#f9f9f9" outline elevation="1">
        <v-row class="px-4 pt-4">

          <v-col md="4" sm="12" xs="12" cols="12" class="my-0 py-0">
            <v-autocomplete
                ref="clientidselect"
                prepend-icon="mdi-account"
                v-model="clientid"
                item-text="text"
                label="Select a client ..."
                :items="clients"
            />
          </v-col>


          <v-col md="4" sm="12" xs="12" cols="12">
            <v-btn @click="submit" dark color="indigo">
              <v-icon class="mr-1">mdi-chart-box-outline</v-icon> Show report
            </v-btn>
          </v-col>
        </v-row>
      </v-sheet>
    </v-row>
    <v-row v-if="showTable" class="mb-4">
      <v-col cols="12">
      <v-simple-table dense>
        <template v-slot:default>
          <thead>
          <tr>
            <th>#</th>
            <th>Date</th>
            <th>Action</th>
            <th>Operation</th>
            <th>Amount</th>
            <th>Balance</th>
          </tr>
          </thead>
          <tbody>
          <tr
              v-for="item in items"
              :key="item.id"
          >
            <td>{{ item.id }}</td>
            <td>{{ item.adddate }}</td>
            <td>{{ item.descr }}</td>
            <td>{{ item.op }}</td>
            <td>${{ item.amount }}</td>
            <td><strong>${{ item.balance }}</strong></td>
          </tr>
          </tbody>
        </template>
      </v-simple-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// @ is an alias to /src

import { __HTTP, FormHeader } from "@/utils/utils";

export default {
  name: "ClientReport",


  methods: {

    getList() {
      this.isloading = true;
      this.items = []
      __HTTP(
          "?do=clientreport",
          JSON.stringify({
            id: this.clientid
          }),
          FormHeader,
          res => {
            console.log(res);
            this.isloading = false;
            this.items = res;
          }
      );
    },
    getClients() {
      this.loading = true;
      __HTTP("?do=getclients", "", FormHeader, res => {
        this.isloading = false;
        this.clients = res;
      });
    },
    submit() {
      if( this.clientid !== null ) {
        this.getList();
        this.showTable = true
      } else {
        this.snackbar = true
        this.$refs.clientidselect.focus();
      }
    }


  },

  created() {
    this.$store.state.title = "Log Report";
    this.getClients();
  },
  components: {},
  data: () => ({
    search: "",
    clientid: null,
    isloading: false,
    showTable: false,
    modal: false,
    count: 0,
    loadingtext: "Please wait while loading data ...",
    clients: [],
    items: [],
    user:[],
    snackbar: false,
  })
};
</script>
